<div class="markdown-editor-wrapper">
  @if (isLoading() && !hasError()) {
    <div class="loader-overlay" role="status">
      <optima-progress-indicator
        [view]="ProcessProgressView.Shimmer"
        [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { width: '100%', height: '100%' }
        ] } }">
      </optima-progress-indicator>
    </div>
  }

  <optima-markdown-wrapper
    [initialValue]="editorContent()"
    [fileId]="id() || ''"
    [autoLoad]="false"
    [draftKey]="'markdown_draft_' + (id() || '')"
    [autosaveInterval]="MarkdownAutosaveInterval.TwoSeconds"
    [thumbnail]="false"
    [fileName]="(selectedBizEntity?.name || 'markdown') + '.md'"
    [mode]="isReadOnly() ? MarkdownViewMode.VIEW : MarkdownViewMode.EDIT"
    [showHeader]="true"
    [showCollaborators]="true"
    [showConnectionStatus]="true"
    [enableDragDrop]="false"
    [showFileUploadButton]="true"
    [toolbar]="markdownToolbar"
    [collaboration]="collaborationAdapter"
    [loading]="isLoading() && !hasError()"
    [showLoadingShimmer]="false"
    [errorMessage]="hasError() ? errorMessage() : ''"
    (retryRequested)="retryLoad()"
    (contentLoaded)="onContentLoaded($event)"
    (loadFailed)="onContentLoadFailed($event)"
    (contentChange)="onEditorContentChange($event)"
    (fileUpload)="onFileUploadClick()">
  </optima-markdown-wrapper>
</div>
